import { render, staticRenderFns } from "./JLpromotion.vue?vue&type=template&id=4bb2f11c&scoped=true"
import script from "./JLpromotion.vue?vue&type=script&lang=js"
export * from "./JLpromotion.vue?vue&type=script&lang=js"
import style0 from "./JLpromotion.vue?vue&type=style&index=0&id=4bb2f11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2f11c",
  null
  
)

export default component.exports